<template>
  <div>
    <ValidationObserver ref="bookingForm" slim>
      <b-form name="BookingPaxFrm" novalidate @submit.prevent="book()">
        <b-row>
          <b-container class="content">
            <div class="printArea" v-show="!showDetails">
              <b-row class="px-2 pb-2">
                <b-col>
                  <img :src="userData.logo" v-if="userData.logo" style="max-height: 50px;" />
                  <img  v-else src="@/assets/images/chr-logo.png" alt="christian tour logo" class="logo-img" style="max-height: 50px;" >
                  <hr>
                </b-col>
              </b-row>
              <HotelInfo :info="result.hotelInfo">
                <b-card class="bg-light summary" no-body>
                  <SearchParamsSummary :params="params" :result="result" :category="category" :meal="meal"/>
                </b-card>
              </HotelInfo>
              <PackageInfo :pack="pack" :currency="params.currency" :showPrices="false" :showNotes="false" :showExtras="false" />
            </div>
            <!-- stacked table -->
            <span v-show="showDetails">
              <b-row>
                <b-col sm="12" class="printArea">
                  <h5 class="package-title" v-translate>Passengers and room details</h5>
                  <b-table-simple stacked="sm" striped caption-top  class="table table-sm text-center">
                    <b-thead class="t-head thead-light text-center">
                      <b-tr>
                        <b-td v-translate>Room</b-td>
                        <b-td></b-td>
                        <b-td v-translate>Last name*</b-td>
                        <b-td v-translate>First name*</b-td>
                        <b-td v-translate>Age</b-td>
                        <b-td v-translate>Date of birth*</b-td>
                        <b-td v-translate>CNP</b-td>
                      </b-tr>
                    </b-thead>
                    <b-tbody v-for="(room,rIndex) in pax" :key="rIndex">
                      <template v-for="(p, pIndex) in room">
                        <PaxForm
                          class="noPrint"
                          v-model="room[pIndex]"
                          :travelDate="travelDate"
                          :room="rIndex + 1"
                          :id="'room' + rIndex + 'pax' + pIndex"
                          :key="'pax' + pIndex"
                        />
                        <div :key="pIndex" style="display: none">
                          <tr>
                            <td>{{ rIndex + 1 }}</td>
                            <td>{{ room[pIndex].title }}</td>
                            <td>{{ room[pIndex].lname }}</td>
                            <td>{{ room[pIndex].fname }}</td>
                            <td>{{ room[pIndex].age }}</td>
                            <td>{{ room[pIndex].bdate }}</td>
                            <td>{{ room[pIndex].cnp }}</td>
                          </tr>
                        </div>
                      </template>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
              </b-row>
              <!-- /stacked table -->
              <InvoicingForm v-model="client" v-if="userData.is_mandated === 't'"/>
              <b-row>
                <b-col md="12">
                  <small><em>* <translate>Fields marked with asterisks are required. The names of the tourists will be entered in capital letters</translate>.</em></small>
                  <hr />
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <h5 class="package-title" v-translate>Telephone No:</h5>
                  <ValidationProvider
                    name="numar de telefon"
                    :rules="{ required: true }"
                    v-slot="vContext"
                    >
                    <b-form-group>
                      <b-form-input
                        type="text"
                        :name="$gettext('name')"
                        :placeholder="$gettext('Telephone number')"
                        class="form-control form-control-sm"
                        v-model="telephone"
                        size="sm"
                        :state="getValidationState(vContext)"
                        aria-describedby="telefon"
                      ></b-form-input>
                      <b-form-invalid-feedback id="telefon">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col sm="6">
                  <h5 class="package-title" v-translate>Email:</h5>
                  <ValidationProvider
                    name="email"
                    :rules="{ required: true }"
                    v-slot="vContext"
                    >
                    <b-form-group>
                      <b-form-input
                        type="text"
                        :name="$gettext('email')"
                        :placeholder="$gettext('Email')"
                        class="form-control form-control-sm"
                        v-model="email"
                        size="sm"
                        :state="getValidationState(vContext)"
                        aria-describedby="email"
                      ></b-form-input>
                      <b-form-invalid-feedback id="email">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <!-- <b-row class="my-3 printArea">
                <b-col>
                  <b-card no-header>
                    <b-row>
                      <b-col>
                        <b v-translate>Selected room category:</b> {{ category.name }}
                      </b-col>
                      <b-col>
                        <b v-translate>Selected meal plan:</b> {{ meal.label }}
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row> -->
              <b-row class="my-3">
                <b-col>
                  <div class="printArea">
                    <h6 v-translate>Agent notes*</h6>
                    <textarea v-model="notes" class="form-control noPrint">...</textarea>
                    <div class="printArea d-none"><p>{{notes}}</p></div>
                  </div>
                  <small>
                    <ValidationProvider
                      name="terms"
                      rules="is:acceptat"
                      vid="terms"
                      v-slot="vContext"
                      slim
                    >
                      <b-form-group>
                        <b-form-checkbox
                          id="conditions"
                          name="conditions"
                          v-model="termsAccepted"
                          :state="getValidationState(vContext)"
                          aria-describedby="conditions-live-feedback"
                          value="acceptat"
                          unchecked-value="neacceptat"
                          >
                            <translate>I have read and agree to the</translate> <span class="text-info" v-translate>Terms and Conditions</span> <translate>of the marketing products.</translate>
                          </b-form-checkbox>
                        <b-form-invalid-feedback id="conditions-live-feedback" :state="getValidationState(vContext)"><translate>you have not accepted the terms and conditions</translate></b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </small>
                </b-col>
              </b-row>
            </span>
            <b-row v-show="!showDetails">
              <Extras
                :extras="category.extras"
                :currency="params.currency"
                :selectable="true"
                :travelDate="travelDate"
                @toggle="onExtraToggle"
                class="printArea"/>
            </b-row>
            <b-row>
              <b-col md="12" class="printArea">
                <b-card
                  bg-variant="light"
                  style="font-size:16px;"
                  class="text-center"
                >
                  <b-form-group>
                    <span><translate>Total price:</translate> <span class="text-price font-weight-bold">{{ price }} {{ params.currency }} </span> <small><translate>(tax included)</translate></small></span>
                    <!-- <br />
                    <small v-for="(dd, ddIndex) in paymentSchedule" :key="'dd' + ddIndex">
                      {{ formatDate(dd.date) }} - <b>{{ ceil(dd.amount) || $gettext('balance') }}</b>
                    </small> -->
                  </b-form-group>
                </b-card>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col>
                <b-card
                  bg-variant="light"
                  no-body
                >
                  <b-card-body class="p-1 p-md-3">
                    <div class="d-md-flex justify-content-md-between">
                      <b-button variant="secondary" size="sm" @click="back" class="mb-2 mb-md-0"><b-icon icon="chevron-left" /><translate>Back to results</translate></b-button>
                      <b-button-group size="sm">
                        <b-button variant="warning" v-show="!showDetails" @click="showDetails = true"><translate>Continue booking</translate></b-button>
                        <b-button variant="warning" v-show="showDetails" @click="showDetails = false"><translate>Back</translate></b-button>
                        <b-button variant="success" type="submit"  @click.prevent="book(false)" v-show="showDetails"><translate>Book</translate></b-button>
                      </b-button-group>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-row>
      </b-form>
    </ValidationObserver>
    <b-modal v-model="showOverlay" :title="$gettext('Status')" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <b-aspect class="align-items-center text-center" aspect="3">
          <b-spinner :label="$gettext('Loading...')" variant="warning"></b-spinner>
          <b-card-text>{{ overlayMessage }}</b-card-text>
        </b-aspect>
      </b-card>
    </b-modal>
    <b-modal v-model="showErrorOverlay" :title="$gettext('Error')" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card class="justify-content-center">
        <b-aspect aspect="3" class="align-items-center">
          <b-card-title class="font-weight-bold text-center">
            <b-icon icon="exclamation-triangle" class="text-danger mr-3"/>
            <translate> There was a problem</translate>
          </b-card-title>
          <hr>
          <b-card-text class="lead text-muted" v-translate> - Unfortunately the reservation could not be registered because a problem occurred.</b-card-text>
          <b-card-text class="lead text-muted" v-translate> - Generally, this happens when the price or availability of the product has changed since you searched.</b-card-text>
          <b-card-text class="lead text-muted" v-translate> The error message is: <b class="text-info">{{ errorMessage }}</b></b-card-text>
        </b-aspect>
        <hr>
        <b-button variant="warning float-right" size="sm" @click="back" v-translate>Back to results</b-button>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import model from '../services/model'
import toast from 'b2b-common/mixins/toast'
import auth from 'b2b-common/mixins/auth'
import validation from 'b2b-common/mixins/validation'
import { $gettext } from '@/config/gettext'

import SearchParamsSummary from './search_params_summary'
import PackageInfo from './package_info'
import Extras from './extras'
import HotelInfo from '@/app/private/shared/components/hotel_info'
import PaxForm from '@/app/private/shared/components/pax_form'
import InvoicingForm from '@/app/private/shared/components/invoicing_info_form'

import { getCustomPdf, downloadPdf, openPrintPage } from 'b2b-common/services/api/document'
import { search, book } from 'b2b-common/services/api/package'

const calculatePrice = (category, meal, selectedExtras) => {
  let p = meal.price + meal.tax
  selectedExtras.forEach(index => {
    if (!category.extras[index]) throw new Error('Extra not found')
    const extra = category.extras[index]
    if (extra.optional) p += extra.price
  })
  return p
}

const invalidFormMessage = $gettext('Invalid Form')

export default {
  name: 'BookForm',
  mixins: [toast, auth, validation],
  props: ['params', 'result', 'pack', 'category', 'meal'],
  components: { PackageInfo, HotelInfo, SearchParamsSummary, InvoicingForm, Extras, PaxForm },
  computed: {
    price () {
      return calculatePrice(this.category, this.meal, this.selectedExtras)
    }
  },
  data () {
    const travelDate = moment.unix(this.params.date)

    const rooms = []
    let noAdults = 0
    let noChildren = 0
    this.params.rooms.forEach(room => {
      const pax = []
      noAdults += room.adults
      noChildren += room.ages.length
      for (let i = 0; i < room.adults; i++) {
        pax.push({
          title: 'MR',
          fname: '',
          lname: '',
          age: 'adult',
          bdate: null,
          cnp: ''
        })
      }
      room.ages.forEach(age => {
        pax.push({
          title: (age < 2) ? 'INF' : 'CHD',
          fname: '',
          lname: '',
          age: age,
          bdate: null,
          cnp: ''
        })
      })
      rooms.push(pax)
    })
    return {
      travelDate,
      noAdults,
      noChildren,
      notes: '',
      telephone: '',
      email: '',
      pax: rooms,
      selectedExtras: [],
      termsAccepted: 'unaccepted',
      client: {
        clientCode: '',
        isCompany: false,
        companyName: '',
        companyNo: '',
        vatNo: '',
        bankAccount: '',
        bankName: '',
        title: 'Mr',
        firstName: '',
        lastName: '',
        idInfo: '',
        cnp: '',
        address1: '',
        address2: '',
        county: '',
        city: '',
        tel: '',
        email: ''
      },
      showErrorOverlay: false,
      showOverlay: false,
      overlayMessage: '',
      errorMessage: this.$gettext('unknown error'),
      // paymentSchedule: [],
      showDetails: false
    }
  },
  // async created () {
  //   this.paymentSchedule = await paymentSchedule({
  //     packageType: model.params.packageType,
  //     result: this.result.index,
  //     pack: this.pack.index,
  //     category: this.category.id,
  //     meal: this.meal.id
  //   })
  // },
  methods: {
    onPrint () {
      this.$refs.bookingForm.validate()
        .then(success => {
          if (!success) {
            this.addToast({ title: invalidFormMessage, message: this.$gettext('Please fill in all required fields!'), variant: 'danger' })
            return
          }
          const arr = document.getElementsByClassName('printArea')
          let html = ''
          arr.forEach(el => {
            html += el.innerHTML
          })
          openPrintPage({ html })
        })
    },
    onDownload () {
      this.$refs.bookingForm.validate()
        .then(success => {
          if (!success) {
            this.addToast({ title: invalidFormMessage, message: this.$gettext('Please fill in all required fields!'), variant: 'danger' })
            return
          }
          const arr = document.getElementsByClassName('printArea')
          let html = ''
          arr.forEach(el => {
            html += el.innerHTML
          })
          getCustomPdf({ html })
            .then(pdfData => {
              downloadPdf({ pdfData, fileName: this.$pgettext('file name do not use special characters, please use ASCII only', 'offer') + '.pdf', dataType: 'raw' })
            })
        })
    },
    back () {
      this.$emit('back')
    },
    async book (isOption = false) {
      try {
        const success = await this.$refs.bookingForm.validate()
        if (!success) {
          this.addToast({ title: invalidFormMessage, message: this.$gettext('Please fill in all required fields!'), variant: 'danger' })
          return Promise.reject(new Error(invalidFormMessage))
        }
        this.showOverlay = true
        this.overlayMessage = this.$gettext('Please wait, we check again the price and availability of the selected product ...')

        // run new search
        const newParams = model.params
        newParams.hotels = [this.result.id]
        model.params = newParams
        const data = await search(newParams)

        // check that availability has not changed
        let avaHasChanged = false
        if (data.has_transport !== model.hasTransport) avaHasChanged = true

        // re-populate model
        model.results = data.results
        model.hasTransport = data.has_transport
        model.sort({ sortMethod: model.sortMethod })

        if (avaHasChanged) throw new Error(this.$gettext('Difference in transport availability found'))

        // check that we can find the same result
        const newResIndex = data.results.findIndex(el => el.id === this.result.id)
        if (newResIndex < 0) throw new Error('Could not find hotel')
        const newResult = data.results[newResIndex]
        const newPackIndex = newResult.packages.findIndex(el => el.id === this.pack.id)
        if (newPackIndex < 0) throw new Error('Could not find package')
        const newPack = newResult.packages[newPackIndex]

        let newCategory = null
        let newMeal = null

        newPack.categories.forEach(category => {
          if (this.category.name === category.name &&
            category.hotelIsAvailable === this.category.hotelIsAvailable &&
            category.hotelIsBlackedOut === this.category.hotelIsBlackedOut &&
            category.isBookable === this.category.isBookable) {
            category.meals.forEach(meal => {
              const p1 = meal.price + meal.tax
              const p2 = this.meal.price + this.meal.tax
              if (meal.code === this.meal.code &&
              meal.label === this.meal.label &&
              p1 === p2) {
                newMeal = meal
                newCategory = category
              }
            })
          }
        })

        if (!newCategory) throw new Error('Could not find category with similar availability')
        if (!newMeal) throw new Error('Could not find result with similar price')

        const pax = [...this.pax.map(room => room.map(p => ({
          title: p.title,
          fname: p.fname.toUpperCase(),
          lname: p.lname.toUpperCase(),
          age: p.age,
          bdate: p.bdate,
          tel: this.telephone ? this.telephone : '',
          email: this.email ? this.email : '',
          cnp: p.cnp ? p.cnp : ''
        })))]

        // send telephone and notes
        let note = this.notes ? this.notes : ''
        if (this.telephone) note += '\nTelefon: ' + this.telephone
        if (this.email) note += '\nEmail: ' + this.email

        // now ok to create booking
        const bookParams = {
          packageType: model.params.packageType,
          category: newCategory.id,
          meal: newMeal.id,
          notes: note,
          extras: this.selectedExtras,
          pax: pax
        }
        if (isOption) bookParams.status = 'option'
        const res = await book(bookParams)

        model.results = []
        this.$emit('book', res[0])
      } catch (err) {
        if (err.message !== invalidFormMessage) {
          this.errorMessage = err.message
          this.showErrorOverlay = true
        }
      } finally { this.showOverlay = false }
    },
    onExtraToggle (extraIndex) {
      const index = this.selectedExtras.indexOf(extraIndex)
      if (index >= 0) this.selectedExtras.splice(index, 1)
      else this.selectedExtras.push(extraIndex)
    },
    formatDate (d) {
      return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    ceil (no) {
      if (no === null || no === undefined) return null
      return Math.ceil(no) + this.params.currency
    }
  }
}
</script>

<style lang="scss">

</style>
